import { motion } from 'framer-motion';
import React from 'react';
import { ScoreBadge } from '../../../components/ui';

interface ContractPreviewCardProps {
  fileName?: string;
  fileSize?: string;
  pageCount?: number;
  previewText?: string;
  score?: number | string;
  contractTitle?: string;
  contractType?: string;
  contractSubType?: string;
  fabButton?: boolean;
  onFabClick?: (clauseTitle: string) => void
  fabIcon?: React.ReactNode;
  tooltip?: string;
}

const ContractPreviewCard: React.FC<ContractPreviewCardProps> = ({
  fileName,
  previewText,
  score,
  contractType,
  contractSubType,
}) => {
  return (
    <div className="relative">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="bg-white rounded-lg shadow-md p-6 mb-3"
      >
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center">
            <div className="bg-blue-100 p-3 rounded-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-8 w-8 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <div className="ml-4">
              <h4 className="text-lg font-semibold text-gray-700">{fileName}</h4>
              <div className="text-sm text-gray-500">
                <span>{contractType}</span>
                {contractSubType && <span> • {contractSubType}</span>}
              </div>
            </div>
          </div>
          {score !== undefined && (
            <div className="flex items-center">
              <ScoreBadge score={score} />
            </div>
          )}
        </div>

        <div className="border-t border-gray-200 pt-4 mt-1">
          <h4 className="font-medium text-gray-700 mb-2">Resumo da nota:</h4>
          <div className="bg-gray-50 p-4 rounded text-gray-600 italic mb-4">{previewText}</div>
        </div>
      </motion.div>

      {/* FAB Button posicionado ao lado direito do card */}
    </div>
  );
};

export default ContractPreviewCard;
